import { ArrayHelper, jobApplication } from "@workspace/common";
import { FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS } from "../../store/report/actionTypes";
import { Images } from "@workspace/common";

// DB data types
const NORMAL = "normal";
const JSONB = "jsonb";

// Report Categories
export const REPORT_CATEGORY = {
  JOBS: "Jobs",
  JOBS_FOD: "Jobs - FOD",
  AVERAGE_TIME: "Average Time",
  CONVERSION_RATIO: "Conversion Ratio",
  GROWTH_RATIO: "Growth Ratio",
  PROFILES: "Profiles",
  COMMERCIALS: "Commercials",
  INTERVIEWS: "Interviews",
  CONDITIONAL_OFFERS: "Conditional Offers",
  TOS: "TOS",
};

// Report Names
export const REPORTS_NAME = {
  [REPORT_CATEGORY.JOBS]: {
    TOTAL_JOBS: "Total Jobs",
    TOTAL_JOBS_ASSIGNED_TO_RECRUITERS: "Total Jobs (Assigned to recruiters)",
    NEW_JOBS: "New Jobs (Unassigned to recruiters)",
    TOTAL_ACTIVE_JOBS: "Total Active Jobs",
    TOTAL_INACTIVE_JOBS: "Total Inactive Jobs",
    TOTAL_CLOSED_WIN_JOBS: "Total Closed Win Jobs",
    TOTAL_CLOSED_LOST_JOBS: "Total Closed Lost Jobs",
    TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS:
      "Total Head Counts/Positions - Active Jobs",
    TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS:
      "Total Head Counts/Positions - New Jobs",
    NO_SUBMISSIONS: "No Submissions",
  },
  [REPORT_CATEGORY.JOBS_FOD]: {
    FOD_TOTAL: "FOD - Total",
    FOD_ACTION_TAKEN: "FOD - Action Taken",
    FOD_NO_ACTION: "FOD - No Action",
    FOD_TOTAL_R: "FOD - Total (By Recruiters)",
    FOD_ACTION_TAKEN_R: "FOD - Action Taken (By Recruiters)",
    FOD_NO_ACTION_R: "FOD - No Action (By Recruiters)",
  },
  [REPORT_CATEGORY.AVERAGE_TIME]: {
    SOURCE_PROFILE: "Source Profile",
    SCREEN_PROFILE: "Screen Profile",
    SUBMIT_TO_SALES: "Submit to Sales",
    SUBMIT_TO_CLIENT: "Submit to Client",
    PROFILE_FEEDBACK_FROM_CLIENT: "Profile Feedback from Client",
    PROFILE_SUBMISSION_TO_INTERVIEW: "Profile Submission to Interview",
  },
  [REPORT_CATEGORY.CONVERSION_RATIO]: {
    NEW_JOB_TO_PROFILE_SHORTLISTED: "New Job to Profile Shortlisted",
    PROFILE_SUBMITTED_TO_CLIENT_REJECTED:
      "Profile Submitted to Client Rejected",
  },
  [REPORT_CATEGORY.PROFILES]: {
    FOD_TOTAL: "FOD - Total Action Taken",
    ACTIVE_RECRUITERS_DISTINCT: "Active Recruiters (Distinct)",
    ACTIVE_RECRUITERS: "Active Recruiters (Profiles worked on)",
    CURRENT_ENGAGEMENTS: "Current Engagements (Profiles worked on)",
    TAG: "Tag",
    ASSOCIATED: "Associated",
    SUBMITTED_TO_SALES: "Submitted to Sales",
    SUBMITTED_TO_CLIENT: "Submitted to Client",
    PROFILE_FEEDBACK_PENDING: "Profile Feedback Pending",
    CANDIDATE_WITHDRAWN: "Candidate Withdrawn",
    PROFILE_REJECTED_BY_SALES: "Profile Rejected by Sales",
    PROFILE_REJECTED_BY_CLIENT: "Profile Rejected by Client",
    // NO_SUBMISSIONS: "No Submissions",
    // REQUIREMENTS_WORKED_ON: "Requirements Worked On",
    // PROFILE_SUBMITTED_TO_INTERVIEWS_HAPPENED:
    //   "Profile Submitted to Interviews Happened",
    // INTERVIEW_HAPPENED_TO_SELECTED: "Interview Happened to Selected",
  },
  [REPORT_CATEGORY.GROWTH_RATIO]: {
    NEW_JOB: "New Job",
    SUBMITTED_TO_CLIENT: "Submitted to Client",
  },
  [REPORT_CATEGORY.COMMERCIALS]: {
    TOTAL_SALARY: "Total Salary",
    AVERAGE_GROSS_MARGIN: "Average Gross Margin",
    TOTAL_BILLING: "Total Billing",
    TOTAL_REVENUE_GROSS_MARGIN: "Total Revenue/Gross Margin",
  },
  [REPORT_CATEGORY.INTERVIEWS]: {
    SCHEDULED_INTERVIEW: "Scheduled Interview",
    // RESCHEDULE_INTERVIEW: "Reschedule Interview",
    INTERVIEW_HAPPENED: "Interview Happened",
    INTERVIEW_BACKOUT_BY_CANDIDATE: "Interview Backout by Candidate",
    INTERVIEW_REJECTED_BY_CLIENT: "Interview Rejected by Client",
    // UPCOMING_INTERVIEWS: "Upcoming Interviews",
    // UNASSIGNED_REQUIREMENTS: "Unassigned Requirements",
    NEW_JOB_TO_SELECTED: "Interview- Candidate Shortlisted",
  },
  [REPORT_CATEGORY.TOS]: {
    PREPARED: "Prepared",
    APPROVED: "Approved",
    REJECTED: "Rejected",
  },
  [REPORT_CATEGORY.CONDITIONAL_OFFERS]: {
    PREPARED: "Prepared",
    RELEASED: "Released",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
  },
};

// Render Icons for Job
export const JOB_ICONS = {
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_JOBS]:
    Images.icons.notification_box,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_JOBS_ASSIGNED_TO_RECRUITERS]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_ACTIVE_JOBS]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_INACTIVE_JOBS]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_CLOSED_WIN_JOBS]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_CLOSED_LOST_JOBS]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].NEW_JOBS]:
    Images.icons.notification_text_2,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS]:
    Images.icons.notification_text_3,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS]:
    Images.icons.notification_text_4,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS].NO_SUBMISSIONS]:
    Images.icons.notification_text,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL]:
    Images.icons.notification_box,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN]:
    Images.icons.notification_text_3,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION]:
    Images.icons.notification_text_2,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL_R]:
    Images.icons.notification_text_1,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN_R]:
    Images.icons.notification_text,
  [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION_R]:
    Images.icons.notification_text_4,
};

export const getReportsData = () => {
  return convertReportsData(REPORTS_NAME);
};

function convertReportsData(reportsData) {
  const result = [];

  for (const key in reportsData) {
    if (Object.hasOwnProperty.call(reportsData, key)) {
      const items = Object.values(reportsData[key]);
      const obj = {};
      obj[key] = items;
      result.push(obj);
    }
  }
  return result;
}

export const NOT_CLICKABLE_REPORTS = [
  REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS,
  REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].SOURCE_PROFILE,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].SCREEN_PROFILE,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].SUBMIT_TO_SALES,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].SUBMIT_TO_CLIENT,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].PROFILE_FEEDBACK_FROM_CLIENT,
  REPORTS_NAME[REPORT_CATEGORY.AVERAGE_TIME].PROFILE_SUBMISSION_TO_INTERVIEW,
  REPORTS_NAME[REPORT_CATEGORY.CONVERSION_RATIO].NEW_JOB_TO_PROFILE_SHORTLISTED,
  REPORTS_NAME[REPORT_CATEGORY.CONVERSION_RATIO]
    .PROFILE_SUBMITTED_TO_CLIENT_REJECTED,
  REPORTS_NAME[REPORT_CATEGORY.GROWTH_RATIO].NEW_JOB,
  REPORTS_NAME[REPORT_CATEGORY.PROFILES].REQUIREMENTS_WORKED_ON,
  REPORTS_NAME[REPORT_CATEGORY.PROFILES]
    .PROFILE_SUBMITTED_TO_INTERVIEWS_HAPPENED,
  REPORTS_NAME[REPORT_CATEGORY.PROFILES].INTERVIEW_HAPPENED_TO_SELECTED,
  REPORTS_NAME[REPORT_CATEGORY.COMMERCIALS].TOTAL_SALARY,
  REPORTS_NAME[REPORT_CATEGORY.COMMERCIALS].AVERAGE_GROSS_MARGIN,
  REPORTS_NAME[REPORT_CATEGORY.COMMERCIALS].TOTAL_BILLING,
  REPORTS_NAME[REPORT_CATEGORY.COMMERCIALS].TOTAL_REVENUE_GROSS_MARGIN,
  REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].UPCOMING_INTERVIEWS,
  REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].UNASSIGNED_REQUIREMENTS,
  REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].RESCHEDULE_INTERVIEW,
];

// Backend report stages constant
export const REPORT_STAGES = {
  ASSOCIATED: "Associated",
  SUBMIT_TO_SALES: "Submitted to Sales",
  SUBMIT_TO_CLIENT: "Submitted to Client",
  NO_SUBMISSION: "No Submission",
  INTERVIEW_SCHEDULED: "Interview Scheduled",
  INTERVIEW_HAPPENED: "Interview Happened",
  SELECTED: "Selected",
  REJECTED: "Rejected",
  PROFILE_WITHDRAWN: "Profile Withdrawn",
  FIRST_INTERVIEW_SCHEDULED: "First Interview Scheduled",
  SECOND_INTERVIEW_SCHEDULED: "Second Interview Scheduled",
  THIRD_INTERVIEW_SCHEDULED: "Third Interview Scheduled",
  FIRST_INTERVIEW_HAPPENED: "First Interview Happened",
  SECOND_INTERVIEW_HAPPENED: "Second Interview Happened",
  THIRD_INTERVIEW_HAPPENED: "Third Interview Happened",
  INTERVIEW_FEEDBACK_PENDING: "Interview Feedback Pending",
  SUBMIT_TO_SALES_REJECTED: "Submit to Sales Rejected",
  SUBMIT_TO_CLIENT_REJECTED: "Submit to Client Rejected",
  TAGGED: "Tagged",
  PROFILE_FEEDBACK: "Profile Feedback",
  INTERVIEW_BACK_OUT: "Interview Back Out",
  INTERVIEW_REJECTED: "Interview Rejected",
  TOS_PREPARED: "TOS Prepared",
  TOS_APPROVED: "TOS Approved",
  TOS_REJECTED: "TOS Rejected",
  CONDITIONAL_OFFER_PREPARED: "Conditional Offer Prepared",
  CONDITIONAL_OFFER_RELEASED: "Conditional Offer Released",
  CONDITIONAL_OFFER_ACCEPTED: "Conditional Offer Accepted",
  CONDITIONAL_OFFER_REJECTED: "Conditional Offer Rejected",
};

export const RECRUITER_PARAMS = {
  ACTIVE_RECRUITERS: "Active Recruiters",
  ACTIVE_RECRUITERS_DISTINCT: "Active Recruiters (Distinct)",
};

export const CURRENT_ENGAGEMENTS_PARAMS = {
  CURRENT_ENGAGEMENTS: "Current Engagements",
};

export const FOD_PARAMS = {
  FOD_TOTAL: "FOD-Total",
};

export const JOB_TYPE = {
  TOTAL_JOB: "total_job",
  NEW_JOB: "new_job",
  ALL_ASSIGNED_JOB: "all_assigned_jobs",
  ACTIVE_JOB: "active_jobs",
  INACTIVE_JOB: "inactive_jobs",
  CLOSED_WIN_JOB: "closed_win_jobs",
  CLOSED_LOST_JOB: "closed_lost_jobs",
  NO_SUBMISSIONS: "no_submissions",
  FOD_TOTAL: "fod_total",
  FOD_ACTION_TAKEN: "fod_action_taken",
  FOD_NO_ACTION: "fod_no_action",
  FOD_TOTAL_R: "fod_total_r",
  FOD_ACTION_TAKEN_R: "fod_action_taken_r",
  FOD_NO_ACTION_R: "fod_no_action_r",
};

export const datePickerConstants = [
  {
    Today: {
      from: new Date(),
      to: new Date(),
    },
  },
  {
    "This Week": {
      from: new Date(
        new Date().setDate(
          new Date().getDate() -
            (new Date().getDay() === 0 ? 6 : new Date().getDay() - 1)
        )
      ),
      to: new Date(),
    },
  },
  {
    "This Month": {
      from: new Date(new Date().setDate(1)), // Start from the 1st day of the current month
      to: new Date(),
    },
  },
  {
    "This Year": {
      from: new Date(new Date().setMonth(0, 1)), // Start from January 1st of the current year
      to: new Date(),
    },
  },
  {
    "Last Week": {
      from: new Date(
        new Date().setDate(
          new Date().getDate() -
            (new Date().getDay() === 0 ? 13 : new Date().getDay() + 6)
        )
      ),
      to: new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay())
      ),
    },
  },
  {
    "Last Month": {
      from: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      to: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    },
  },
  {
    "Last Year": {
      from: new Date(new Date().getFullYear() - 1, 0, 1),
      to: new Date(new Date().getFullYear() - 1, 11, 31),
    },
  },
  {
    "Custom Range": {
      from: null,
      to: null,
    },
  },
];

// Filter Labels
export const FILTER_LABELS = {
  dateRange: "Date Range",
  salesPerson: "Sales Person",
  recruiter: "Recruiter",
  // client: "Client",
  accountName: "Account Name",
  country: "Country",
  currentStage: "Current Stage",
  jobType: "Job Type",
  jobStatus: "Job Status",
};

// Custom View Type
export const CUSTOM_VIEW_TYPE = {
  JOB_UNIVERSAL_REPORT: "Job Universal Report",
  JOB_UNIVERSAL_REPORT_JOB_LISTING: "Job Universal Report - Job Listing",
};

// Form Name
export const FORM_NAME = {
  JOB: "job_form",
  CANDIDATE: "Candidate_basic_info",
};

export const INITIAL_REPORT_FILTER = [
  { label: FILTER_LABELS.dateRange, field: "job_timeline.created_at" },
  {
    label: FILTER_LABELS.salesPerson,
    field: "job.job_submission_data.accountOwner",
  },
  { label: "Recruiter", field: "users.first_name + users.last_name" },
  { label: "Client", field: "job.job_submission_data.accountName" },
  { label: "Country", field: "job.job_submission_data.country" },
];

export const UNIVERSAL_REPORT_STATIC_INITIAL_OPTIONS = [
  {
    sortValue: "job.job_submission_data.jobId",
    label: "Pulse Job ID",
    value: "job.jobSubmissionData.jobId",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    sortValue: "job.job_submission_data.jobTitle",
    label: "Job Title",
    value: "job.jobSubmissionData.jobTitle",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    label: "Candidate Name",
    value: "candidate.candidateSubmissionData.firstName",
    sort: true,
    sortValue: "candidate.candidate_submission_data.firstName",
    expand: true,
    sortType: "jsonb",
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    sortValue: "job.job_submission_data.jobType",
    label: "Job Type",
    value: "job.jobSubmissionData.jobType",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job.job_submission_data.jobStatus",
    label: "Job Status",
    value: "job.jobSubmissionData.jobStatus",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "created_at",
    label: "Job Created Date",
    value: "createdAt",
    sort: true,
    expand: true,
    sortType: NORMAL,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job.job_submission_data.country",
    label: "Country",
    value: "job.jobSubmissionData.country",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.workLocation",
    label: "Work Location",
    value: "job.jobSubmissionData.workLocation",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.accountName",
    label: "Account Name",
    value: "job.jobSubmissionData.accountName",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: "custom",
    element: "custom", // Used to display the custom filter element
  },
  {
    sortValue: "job.job_submission_data.accountContact",
    label: "Account Contact",
    value: "job.jobSubmissionData.accountContact",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: NORMAL,
    element: NORMAL, // Used to display the custom filter element
  },
  {
    sortValue: "job.job_submission_data.accountOwner",
    label: "Sales Person",
    value: "job.jobSubmissionData.accountOwner",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: "custom",
    element: "custom", // Used to display the custom filter element
  },
  {
    sortValue: "users.first_name",
    label: "Recruiter",
    value: "createdByName",
    sort: true,
    expand: true,
    sortType: NORMAL,
    dbDataType: NORMAL,
    filterType: "custom",
    element: "custom", // Used to display the custom filter element
  },
  {
    label: "Candidate Email",
    value: "candidate.candidateSubmissionData.email",
    sort: true,
    sortValue: "candidate.candidate_submission_data.email",
    expand: true,
    sortType: "jsonb",
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    label: "Phone Number Code",
    value: "candidate.candidateSubmissionData.phoneCode",
    sort: true,
    sortValue: "candidate.candidate_submission_data.phoneCode",
    expand: true,
    sortType: "jsonb",
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    label: "Phone Number",
    value: "candidate.candidateSubmissionData.phone",
    sort: true,
    sortValue: "candidate.candidate_submission_data.phone",
    expand: true,
    sortType: "jsonb",
    dbDataType: JSONB,
    filterType: NORMAL,
  },
  {
    label: "Current Candidate Status",
    value: "subStepName",
    sort: true,
    sortValue: "sub_step_name",
    expand: true,
    sortType: "normal",
    dbDataType: NORMAL,
    filterType: NORMAL,
  },
  {
    label: "Updated Date",
    value: "updatedAt",
    sort: true,
    sortValue: "job_timeline.updated_at",
    expand: true,
    sortType: "normal",
    dbDataType: NORMAL,
    filterType: NORMAL,
  },
  {
    label: "Timeline Bill Rate",
    value: "billRate",
    sort: true,
    sortValue: "job_timeline.bill_rate",
    expand: true,
    sortType: "normal",
    dbDataType: "bigint",
    filterType: NORMAL,
  },
  {
    label: "Ageing",
    value: "job.jobSubmissionData.dateOpen",
    sort: true,
    sortValue: "job.job_submission_data.dateOpen",
    sortType: "jsonb",
    expand: true,
    dbDataType: JSONB,
    filterType: NORMAL,
  },
];

export const UNIVERSAL_REPORT_STATIC_MANDATORY_OPTIONS = [];

export const UNIVERSAL_REPORT_STATIC_INITIAL_OPTIONS_FILTER = [
  ...UNIVERSAL_REPORT_STATIC_INITIAL_OPTIONS,
  {
    label: "Country",
    sortValue: "job.job_submission_data.country",
    value: "job.jobSubmissionData.country",
    sort: true,
    expand: true,
    sortType: JSONB,
    dbDataType: JSONB,
    filterType: "custom",
    element: "custom",
  },
];

export const buildOptionsArray = (
  formSchema,
  valuePrefix = "",
  sortValuePrefix = "",
  groupedLabel = ""
) => {
  const options = [];
  formSchema?.forEach((field) => {
    if (field?.name && field?.name !== "") {
      const data = {};
      data.label = formatString(field.name);
      data.value = valuePrefix + "." + field?.name;
      data.sortValue = sortValuePrefix + "." + field?.name;
      data.sort = true;
      data.sortType = "jsonb";
      data.dbDataType = "jsonb";
      if (groupedLabel) {
        data.groupedLabel = groupedLabel;
      }
      options.push(data);
    }
    // Sub name
    if (field?.subName && field?.subName !== "") {
      const data = {};
      data.label = formatString(field?.subName);
      data.value = valuePrefix + "." + field?.subName;
      data.sortValue = sortValuePrefix + "." + field?.subName;
      data.sort = true;
      data.sortType = "jsonb";
      data.dbDataType = "jsonb";
      if (groupedLabel) {
        data.groupedLabel = groupedLabel;
      }
      options.push(data);
    }
  });

  return options;
};

function formatString(input) {
  // Remove asterisk if present
  input = input.replace("*", "");

  // Convert camelCase to space-separated words with proper capitalization
  let result = input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
    .replace(/([A-Z])/g, " $1") // Add space before each capital letter
    .trim(); // Remove leading/trailing spaces

  // Capitalize the first letter of each word
  result = result
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return result;
}

export const generateUniversalReportFields = (candidateForm, jobForm) => {
  const universalReportFields = [
    ...UNIVERSAL_REPORT_STATIC_INITIAL_OPTIONS_FILTER,
  ];
  if (candidateForm) {
    const candidateOptions = buildOptionsArray(
      candidateForm?.formSchema,
      "candidate.candidateSubmissionData",
      "candidate.candidate_submission_data",
      "Candidate"
    );
    universalReportFields.push(...candidateOptions);
  }

  if (jobForm) {
    const jobOptions = buildOptionsArray(
      jobForm?.formSchema,
      "job.jobSubmissionData",
      "job.job_submission_data",
      "Job"
    );
    jobOptions.push({
      dbDataType: "normal",
      groupedLabel: "Job",
      label: "Job Created Date",
      sort: true,
      sortType: "normal",
      sortValue: "job.created_at",
      value: "job.createdAt",
    });
    universalReportFields.push(...jobOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const uniqueUniversalReportFieldsNew = universalReportFields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  // Fix Labels Here
  const changeLabelsMap = {
    "job.jobSubmissionData.clientName": "End Client Name",
  };

  uniqueUniversalReportFieldsNew.forEach((field) => {
    if (changeLabelsMap[field.value]) {
      field.label = changeLabelsMap[field.value];
    }
  });

  ArrayHelper.sortArrayObjIcase(uniqueUniversalReportFieldsNew, "label");
  return uniqueUniversalReportFieldsNew;
};

export const generateGroupedOptions = (
  options,
  defaultGroupedLabel = "Default"
) => {
  const newOptions = [];
  options.forEach((option) => {
    const groupedLabel = option.groupedLabel || defaultGroupedLabel;
    const existingGroup = newOptions.find((opt) => opt.label === groupedLabel);
    if (existingGroup) {
      existingGroup.options.push(option);
    } else {
      newOptions.push({
        label: groupedLabel,
        options: [option],
      });
    }
  });
  return newOptions;
};

export const RECRUITER_DISTINCT_OPTIONS = [
  {
    sortValue: "users.first_name",
    label: "Recruiter",
    value: "createdByName",
    sort: true,
    expand: true,
    sortType: NORMAL,
    dbDataType: NORMAL,
    filterType: "custom",
    element: "custom", // Used to display the custom filter element
  },
];

// Check for Recruiters FOD jopsteps
export const checkFODRTypes = (jobStep) => {
  return (
    jobStep === JOB_TYPE.FOD_TOTAL_R ||
    jobStep === JOB_TYPE.FOD_ACTION_TAKEN_R ||
    jobStep === JOB_TYPE.FOD_NO_ACTION_R
  );
};

export const getReportInformation = (reportCategory, reportName) => {
  switch (reportCategory) {
    case REPORT_CATEGORY.JOBS:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_JOBS:
          return "Total number of jobs";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS]
          .TOTAL_JOBS_ASSIGNED_TO_RECRUITERS:
          return "Total number of active jobs that are assigned to recruiters";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS].NEW_JOBS:
          return "Total number of new jobs that are not assigned to recruiters";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS]
          .TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS:
          return "Total head counts/positions for active jobs";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS]
          .TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS:
          return "Total head counts/positions for new jobs";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS].NO_SUBMISSIONS:
          return "Total number active jobs with no submissions (not tagged)";
        default:
          return;
      }
    case REPORT_CATEGORY.JOBS_FOD:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL:
          return "Total number of distinct number of jobs with FOD";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN:
          return "Total number of distinct jobs with FOD where action has been taken";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION:
          return "Total number of distinct jobs with FOD where action has not been taken";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL_R:
          return "Total number of jobs with FOD, broken down by recruiter. If a job has multiple recruiters, each recruiter will be counted separately";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN_R:
          return "Total number of jobs with FOD where action has been taken, broken down by recruiter. If a job has multiple recruiters, each recruiter will be counted separately";
        case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION_R:
          return "Total number of jobs with FOD where no action has been taken, broken down by recruiter. If a job has multiple recruiters, each recruiter will be counted separately";
        default:
          return;
      }
    case REPORT_CATEGORY.PROFILES:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].FOD_TOTAL:
          return "Count of candidates tagged by each recruiter with FOD for a job. If a recruiter tags multiple candidates for the same job, each candidate will be counted separately";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].ACTIVE_RECRUITERS_DISTINCT:
          return "Count of distinct recruiters who have tagged candidates";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].ACTIVE_RECRUITERS:
          return `Count: Displays the number of distinct recruiters who have tagged candidates.
          
          Listing Details: When clicked, the list will show recruiters who have tagged candidates, with each tagged candidate counted separately. If a recruiter tags multiple candidates, each candidate will be listed and counted individually
          `;
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].CURRENT_ENGAGEMENTS:
          return `Count: Displays the unique number of jobs that has been worked upon.

          Listing Details: When clicked, it shows a breakdown of each job's timeline that has been worked upon. Each job timeline will be counted separately`;
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].TAG:
          return "Total number of profiles tagged to a job";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].ASSOCIATED:
          return "Total number of profiles associated with a job";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_SALES:
          return "Total number of profiles submitted to sales";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_CLIENT:
          return "Total number of profiles submitted to client";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_FEEDBACK_PENDING:
          return "Total number of profiles that has submitted to client and waiting for feedback";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].CANDIDATE_WITHDRAWN:
          return "Total number of profiles that has been withdrawn by the candidate";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_REJECTED_BY_SALES:
          return "Total number of profiles rejected by sales";
        case REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_REJECTED_BY_CLIENT:
          return "Total number of profiles rejected by client";
        default:
          return;
      }
    case REPORT_CATEGORY.INTERVIEWS:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].SCHEDULED_INTERVIEW:
          return `Count: Displays the number of interviews scheduled. Each candidate tagged may have multiple interviews scheduled for the same day. If a candidate has multiple interviews scheduled, each interview will be counted separately.
           
          Listing Details: When clicked, the list will show the distinct number of job timeline with interview(s) scheduled.`;
        case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].INTERVIEW_HAPPENED:
          return `Count: Displays the number of interviews that have happened. Each candidate tagged may have multiple interviews scheduled for the same day. If a candidate has multiple interviews scheduled, each interview will be counted separately.
          
          Listing Details: When clicked, the list will show the distinct number of job timeline with interview(s) happened.`;
        case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS]
          .INTERVIEW_BACKOUT_BY_CANDIDATE:
          return "Total number of interviews backout by candidate";
        case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS]
          .INTERVIEW_REJECTED_BY_CLIENT:
          return "Total number of interviews rejected by client";
        case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].NEW_JOB_TO_SELECTED:
          return "Total number of interviews selected";
        default:
          return;
      }
    case REPORT_CATEGORY.CONDITIONAL_OFFERS:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].PREPARED:
          return "Total number of conditional offers prepared";
        case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].RELEASED:
          return "Total number of conditional offers released";
        case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].ACCEPTED:
          return "Total number of conditional offers accepted";
        case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].REJECTED:
          return "Total number of conditional offers rejected";
        default:
          return;
      }
    case REPORT_CATEGORY.TOS:
      switch (reportName) {
        case REPORTS_NAME[REPORT_CATEGORY.TOS].PREPARED:
          return "Total number of TOS (term of service) prepared";
        case REPORTS_NAME[REPORT_CATEGORY.TOS].APPROVED:
          return "Total number of TOS (term of service) approved";
        case REPORTS_NAME[REPORT_CATEGORY.TOS].REJECTED:
          return "Total number of TOS (term of service) rejected";
        default:
          return;
      }
    default:
      return;
  }
};

const getScheduledInterviewCount = (reportCount, checkIsCurrentStage) => {
  if (checkIsCurrentStage()) {
    return reportCount?.interviewScheduledCount;
  }
  const firstInterviewScheduleCount =
    reportCount?.interviewScheduledFirstCount || 0;
  const secondInterviewScheduleCount =
    reportCount?.interviewScheduledSecondCount || 0;
  const thirdInterviewScheduleCount =
    reportCount?.interviewScheduledThirdCount || 0;
  return (
    firstInterviewScheduleCount +
    secondInterviewScheduleCount +
    thirdInterviewScheduleCount
  );
};

const getInterviewHappenedCount = (reportCount, checkIsCurrentStage) => {
  if (checkIsCurrentStage()) {
    return reportCount?.interviewHappenedCount;
  }
  const interviewHappenedFirstCount =
    reportCount?.interviewHappenedFirstCount || 0;
  const interviewHappenedSecondCount =
    reportCount?.interviewHappenedSecondCount || 0;
  const interviewHappenedThirdCount =
    reportCount?.interviewHappenedThirdCount || 0;
  return (
    interviewHappenedFirstCount +
    interviewHappenedSecondCount +
    interviewHappenedThirdCount
  );
};

export const generateReportData = (
  reportCount,
  jobReportCount,
  checkIsCurrentStage
) => {
  const reportData = [
    {
      header: "Jobs",
      headerCell: "A1", // Header will be placed in cell A1
      data: {
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]?.TOTAL_JOBS]:
          jobReportCount?.totalRequirementsCount,
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]
          ?.TOTAL_JOBS_ASSIGNED_TO_RECRUITERS]:
          jobReportCount?.allAssignedRequirementsCount,
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]?.TOTAL_ACTIVE_JOBS]:
          jobReportCount?.activeRequirementsCount,
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]?.TOTAL_INACTIVE_JOBS]:
          jobReportCount?.inactiveRequirementsCount,
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]?.TOTAL_CLOSED_WIN_JOBS]:
          jobReportCount?.closedWinRequirementsCount,
        [REPORTS_NAME?.[REPORT_CATEGORY.JOBS]?.TOTAL_CLOSED_LOST_JOBS]:
          jobReportCount?.closedLostRequirementsCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS].NEW_JOBS]:
          jobReportCount?.newRequirementsCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS]
          .TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS]:
          jobReportCount?.activeJobHeadCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS]
          .TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS]:
          jobReportCount?.newJobHeadCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS].NO_SUBMISSIONS]:
          jobReportCount?.noSubmissionsJobCount,
      },
      startingDataCell: "A2",
    },
    {
      header: "Jobs - FOD",
      headerCell: "A9",
      data: {
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL]:
          jobReportCount?.fodTotalCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN]:
          jobReportCount?.fodActionTakenCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION]:
          jobReportCount?.fodNoActionCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL_R]:
          jobReportCount?.fodTotalRCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN_R]:
          jobReportCount?.fodActionTakenRCount,
        [REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION_R]:
          jobReportCount?.fodNoActionRCount,
      },
      startingDataCell: "A10",
    },
    {
      header: "Profiles",
      headerCell: "D1",
      data: {
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].FOD_TOTAL]:
          reportCount?.fodTotalCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].ACTIVE_RECRUITERS_DISTINCT]:
          reportCount?.activeRecruitersCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].ACTIVE_RECRUITERS]: `${
          reportCount?.activeRecruitersCount || 0
        } (${reportCount?.activeRecruitersListingCount || 0})`,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].CURRENT_ENGAGEMENTS]: `${
          reportCount?.currentEngagementsCount || 0
        } (${reportCount?.currentEngagementsListingCount || 0})`,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].TAG]: reportCount?.taggedCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].ASSOCIATED]:
          reportCount?.associatedCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_SALES]:
          reportCount?.submitToSalesCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_CLIENT]:
          reportCount?.submitToClientCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_FEEDBACK_PENDING]:
          reportCount?.profileFeedbackCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].CANDIDATE_WITHDRAWN]:
          reportCount?.profileWithdrawnCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_REJECTED_BY_SALES]:
          reportCount?.submitToSalesRejectedCount,
        [REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_REJECTED_BY_CLIENT]:
          reportCount?.submitToClientRejectedCount,
      },
      startingDataCell: "D2",
    },
    {
      header: "Interviews",
      headerCell: "G1",
      data: {
        [REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].SCHEDULED_INTERVIEW]:
          getScheduledInterviewCount(reportCount, checkIsCurrentStage),
        [REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].INTERVIEW_HAPPENED]:
          getInterviewHappenedCount(reportCount, checkIsCurrentStage),
        [REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS]
          .INTERVIEW_BACKOUT_BY_CANDIDATE]: reportCount?.interviewBackOutCount,
        [REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].INTERVIEW_REJECTED_BY_CLIENT]:
          reportCount?.interviewRejectedCount,
        [REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].NEW_JOB_TO_SELECTED]:
          reportCount?.interviewFeedbackPendingCount,
      },
      startingDataCell: "G2",
    },
    {
      header: "TOS",
      headerCell: "G8",
      data: {
        [REPORTS_NAME[REPORT_CATEGORY.TOS].PREPARED]:
          reportCount?.tosPreparedCount,
        [REPORTS_NAME[REPORT_CATEGORY.TOS].APPROVED]:
          reportCount?.tosApprovedCount,
        [REPORTS_NAME[REPORT_CATEGORY.TOS].REJECTED]:
          reportCount?.tosRejectedCount,
      },
      startingDataCell: "G9",
    },
    {
      header: "Conditional Offers",
      headerCell: "G13",
      data: {
        [REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].PREPARED]:
          reportCount?.conditionalOfferPreparedCount,
        [REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].RELEASED]:
          reportCount?.conditionalOfferReleasedCount,
        [REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].ACCEPTED]:
          reportCount?.conditionalOfferAcceptedCount,
        [REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].REJECTED]:
          reportCount?.conditionalOfferRejectedCount,
      },
      startingDataCell: "G14",
    },
  ];
  return reportData;
};

export const removeExternalFilters = (
  defaultCustomView,
  dispatch,
  setDefaultCustomView,
  bubbleExternalFilter,
  setBubbleExternalFilter
) => {
  const newDefaultCustomView = JSON.parse(JSON.stringify(defaultCustomView));
  const externalFiltersLabel = [
    "Account Name",
    "Recruiter",
    "Sales Person",
    "Country",
    "Job Type",
    "Job Status",
  ];
  // Remove all the filter if it exists
  externalFiltersLabel.forEach((label) => {
    if (newDefaultCustomView?.filters) {
      newDefaultCustomView.filters = newDefaultCustomView.filters.filter(
        (filter) => filter.label !== label
      );
    }
  });
  dispatch(setDefaultCustomView(newDefaultCustomView));
  // Remove  externalFiltersLabel the filter from the bubble filter
  let newBubbleExternalFilter = JSON.parse(
    JSON.stringify(bubbleExternalFilter)
  );
  externalFiltersLabel.forEach((label) => {
    if (newBubbleExternalFilter && newBubbleExternalFilter?.length > 0) {
      newBubbleExternalFilter = newBubbleExternalFilter?.filter(
        (filter) => filter.label !== label
      );
    }
  });
  setBubbleExternalFilter(newBubbleExternalFilter);
};

export const reportTypeBorder = [
  "Total Jobs",
  "New Jobs (Unassigned to recruiters)",
  "Total Closed Lost Jobs",
  "Total Head Counts/Positions - New Jobs",
];
